import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import '../styles/HelpPage.css';
import Sidebar from "../components/Sidebar.js";
import Header from "../components/Header.js";
import nextPage from "../images/nextPage.png"
import prevPage from "../images/prevPage.png"
import nextSection from "../images/nextSection.png"
import prevSection from "../images/prevSection.png"
import openDD from "../images/openDD.png"
import closeDD from "../images/closeDD.png"

const HelpPage = () => {
  const [activeItem, setActiveItem] = useState("help");
   const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item
    if (item === "dashboard") {
      navigate("/dashboard"); // Navigate to dashboard
    } else if (item === "bookmarks") {
      navigate("/bookmarks"); // Navigate to bookmarks
    } else if (item === "library") {
      navigate("/library"); // Navigate to library
    } else if (item === "settings") {
      navigate("/settings"); // Navigate to settings
    }else if (item === "help") {
        navigate("/help"); // Navigate to settings
      }
    
    resetSearch(); // Reset search whenever a new section is selected
  };

  const getHeaderVisibility = () => {
    if (activeItem === "dashboard" || activeItem === "") {
      return { showSearch: true, showUserProfile: true, showArrows: true, pageName: "Dashboard" };
    } else if (activeItem === "bookmarks") {
      return { showSearch: true, showUserProfile: true, showArrows: true, pageName: "" };
    } else if (activeItem === "library") {
      return { showSearch: false, showUserProfile: true, showArrows: true, pageName: "My Library" };
    } else if (activeItem === "settings") {
      return { showSearch: false, showUserProfile: true, showArrows: true, pageName: "Account" };
    }else if (activeItem === "help") {
        return { showSearch: true, showUserProfile: true, showArrows: true, pageName: "" };
    }
    else {
      return { showSearch: false, showUserProfile: true, showArrows: true, pageName:"Search Results"};
    }
  };
  const { showSearch, showUserProfile, showArrows, pageName } = getHeaderVisibility();

  const handleProfileClick = () => {
    navigate("/settings", { state: { selectedSection: "account" } });
  };

  return (
    <main className="main-content">
      <div className="sidebar_container">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          resetSearch={resetSearch}
        />
      </div>
      <div className="help_container">
        <div className="header_container">
          <Header
            showSearch={showSearch}
            showUserProfile={showUserProfile}
            showArrows={showArrows} 
            pageName={pageName} 
            searchQuery={searchQuery}
            onSearch={(query) => setSearchQuery(query)}
            onProfileClick={handleProfileClick} 
          />
        </div>
        <div className="help_body">
          <div className="help">
            <div className="keyboard-shortcuts">
              <h1>Keyboard Shortcuts</h1>
              
              <div className="shortcut-row">
                <span>Next Page</span>
                {/* Replace with your complete CTRL + → image */}
                <div className="shortcut-image"><img src={nextPage} alt="CTRL + →" /></div>
              </div>
              
              <div className="shortcut-row">
                <span>Prev Page</span>
                {/* Replace with your complete CTRL + ← image */}
                <div className="shortcut-image"><img src={prevPage} alt="CTRL + ←" /></div>
                
              </div>
              
              <div className="shortcut-row">
                <span>Next Section</span>
                {/* Replace with your complete ALT + → image */}
                <div className="shortcut-image"><img src={nextSection} alt="ALT + →" /></div>
                
              </div>
              
              <div className="shortcut-row">
                <span>Previous Section</span>
                {/* Replace with your complete ALT + ← image */}
                <div className="shortcut-image"><img src={prevSection} alt="ALT + ←" /></div>
              </div>
              
              <div className="shortcut-row">
                <span>Select Pages - drop-down open</span>
                {/* Replace with your complete CTRL + ↓ image */}
                <div className="shortcut-image"><img src={openDD} alt="CTRL + ↓" /></div>
              </div>
              
              <div className="shortcut-row">
                <span>Select Pages - drop-down close</span>
                {/* Replace with your complete CTRL + ↑ image */}
                <div className="shortcut-image"><img src={closeDD} alt="CTRL + ↑" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default HelpPage;
